export interface Category {
  name: string;
  url: string;
  icon: string;
  description: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Latest sneaker and shoe spreadsheet finds',
    image: 'https://readdy.ai/api/search-image?query=Street%20style%20sneakers%20on%20urban%20concrete%20floor%20with%20colorful%20graffiti%20wall%20backdrop%20edgy%20editorial%20photography%20cool%20grey%20and%20muted%20orange%20tones%20dramatic%20shadow%20play%20high%20contrast%20artistic%20composition&width=480&height=480&seq=cat-v2-shoes&orientation=squarish',
  },
  {
    name: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodie and sweater spreadsheet collections',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20knit%20sweater%20draped%20on%20rustic%20wooden%20cabin%20floorboard%20warm%20fireplace%20amber%20glow%20in%20background%20soft%20candlelight%20rustic%20chic%20aesthetic%20deep%20forest%20green%20and%20burnt%20orange%20tones%20lifestyle%20editorial%20photography&width=480&height=480&seq=cat-v2-hoodies&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Trending t-shirt finds in Kakobuy spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20band%20graphic%20t-shirt%20folded%20on%20distressed%20wooden%20coffee%20table%20with%20espresso%20cup%20and%20vinyl%20records%20nearby%20indie%20record%20store%20aesthetic%20warm%20tungsten%20lighting%20moody%20atmosphere%20deep%20browns%20and%20faded%20blacks%20editorial%20style&width=480&height=480&seq=cat-v2-tshirts&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Best jacket spreadsheet picks and deals',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20motorcycle%20jacket%20hanging%20on%20industrial%20metal%20clothing%20rack%20in%20converted%20warehouse%20space%20exposed%20brick%20wall%20background%20dramatic%20overhead%20lighting%20moody%20editorial%20photography%20charcoal%20grey%20and%20deep%20burgundy%20tones&width=480&height=480&seq=cat-v2-jackets&orientation=squarish',
  },
  {
    name: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Popular pants and shorts spreadsheet listings',
    image: 'https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20neatly%20laid%20on%20bamboo%20mat%20with%20tropical%20monstera%20leaves%20casting%20shadows%20resort%20vacation%20aesthetic%20bright%20natural%20sunlight%20streaming%20through%20rattan%20blinds%20soft%20sandy%20beige%20and%20sage%20green%20tones%20editorial%20lifestyle%20photography&width=480&height=480&seq=cat-v2-pants&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-gallery-line',
    description: 'Caps, beanies and headwear spreadsheet finds',
    image: 'https://readdy.ai/api/search-image?query=Baseball%20cap%20resting%20on%20vintage%20skateboard%20deck%20against%20sunlit%20skate%20park%20ramp%20urban%20streetwear%20aesthetic%20golden%20hour%20sunlight%20vibrant%20blue%20sky%20backdrop%20cool%20cyan%20and%20warm%20amber%20tones%20contemporary%20editorial%20photography&width=480&height=480&seq=cat-v2-headwear&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Complete outfit sets in the spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Matching%20athleisure%20workout%20set%20displayed%20on%20gym%20bench%20with%20dumbbells%20in%20soft%20focus%20background%20bright%20gym%20lighting%20clean%20fitness%20aesthetic%20crisp%20white%20and%20electric%20coral%20tones%20high%20energy%20editorial%20style&width=480&height=480&seq=cat-v2-sets&orientation=squarish',
  },
  {
    name: 'Underwear & Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-heart-line',
    description: 'Essential underwear spreadsheet collections',
    image: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20basics%20arranged%20on%20crisp%20white%20linen%20bedding%20with%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20peaceful%20bedroom%20aesthetic%20soft%20pastel%20peach%20and%20dove%20grey%20tones%20airy%20minimalist%20editorial%20photography&width=480&height=480&seq=cat-v2-underwear&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Sports jersey spreadsheet finds and deals',
    image: 'https://readdy.ai/api/search-image?query=Classic%20vintage%20football%20jersey%20draped%20over%20wooden%20locker%20room%20bench%20with%20stadium%20floodlights%20visible%20through%20window%20competitive%20sports%20aesthetic%20dramatic%20lighting%20deep%20navy%20and%20white%20tones%20nostalgic%20editorial%20photography&width=480&height=480&seq=cat-v2-jersey&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    description: 'Must-have accessories from the spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Layered%20gold%20chain%20necklaces%20and%20minimalist%20rings%20scattered%20on%20rich%20black%20velvet%20surface%20jewelry%20boutique%20display%20aesthetic%20dramatic%20spotlight%20reflection%20luxurious%20warm%20gold%20and%20deep%20black%20tones%20high%20end%20editorial%20photography&width=480&height=480&seq=cat-v2-accessories&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Stylish bag spreadsheet recommendations',
    image: 'https://readdy.ai/api/search-image?query=Rugged%20canvas%20backpack%20resting%20on%20moss%20covered%20rock%20along%20forest%20hiking%20trail%20outdoor%20adventure%20aesthetic%20dappled%20sunlight%20filtering%20through%20pine%20trees%20earthy%20olive%20green%20and%20warm%20brown%20tones%20cinematic%20nature%20editorial%20photography&width=480&height=480&seq=cat-v2-bags&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Quality belt spreadsheet picks',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20braided%20leather%20belt%20coiled%20on%20weathered%20barn%20wood%20surface%20with%20antique%20brass%20buckle%20western%20Americana%20aesthetic%20soft%20afternoon%20sunlight%20casting%20long%20shadows%20rich%20cognac%20leather%20tones%20rustic%20editorial%20photography&width=480&height=480&seq=cat-v2-belts&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Fragrance spreadsheet discoveries',
    image: 'https://readdy.ai/api/search-image?query=Crystal%20cut%20perfume%20bottle%20standing%20on%20elegant%20mirrored%20vanity%20tray%20with%20fresh%20rose%20petals%20scattered%20around%20luxury%20boudoir%20aesthetic%20soft%20candlelight%20reflections%20rosy%20pink%20and%20silver%20tones%20glamorous%20editorial%20photography&width=480&height=480&seq=cat-v2-perfumes&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-add-line',
    description: 'More hidden gems in the spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Eclectic%20collection%20of%20wireless%20earbuds%20phone%20case%20and%20smartwatch%20laid%20on%20modern%20tech%20desk%20with%20neon%20accent%20lighting%20gaming%20setup%20aesthetic%20vibrant%20purple%20and%20electric%20blue%20tones%20futuristic%20editorial%20product%20photography&width=480&height=480&seq=cat-v2-other&orientation=squarish',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const articleSlugs = [
  {
    slug: 'what-is-kakobuy-spreadsheet',
    title: 'What Is Kakobuy Spreadsheet? The Ultimate 2026 Guide to Finding Products Smarter',
    description: 'Learn everything about Kakobuy Spreadsheet — how it works, why thousands of shoppers use it daily, and how you can discover trending products before everyone else.',
    readTime: '8 min read',
  },
  {
    slug: 'kakobuy-spreadsheet-tips',
    title: '10 Expert Kakobuy Spreadsheet Tips to Find Hidden Gems Faster in 2026',
    description: 'Master the Kakobuy Spreadsheet with these insider tips. Learn how to filter, sort, and discover products that other shoppers miss entirely.',
    readTime: '6 min read',
  },
  {
    slug: 'kakobuy-spreadsheet-vs-alternatives',
    title: 'Kakobuy Spreadsheet vs Alternatives: Which Product Database Is Right for You?',
    description: 'A detailed comparison of Kakobuy Spreadsheet against CSSBuy, Superbuy, and Oopbuy spreadsheets. Find out which platform gives you the best product discovery experience.',
    readTime: '10 min read',
  },
];